import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    width: '160px',
    // height: '182px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '16px',
    border: '1px solid #0000001A',
    alignItems: 'center',
    borderRadius: '16px',
    background: '#00000066',
  },
  image: {
    width: '100px',
    height: '100px',
  },
  title: {
    textAlign: 'center',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
